import * as React from 'react';
import config from 'config';
import { FormattedMessage } from 'mz-intl';
import { useSelector } from 'react-redux';
import {
  isBookByCustomer,
  getBookingTrip,
  behavesAsTravelAgent,
} from 'app/sagas/selectors';
import { Field } from 'redux-form';
import { styled } from 'mz-ui-kit';
import { getMainStep } from 'mz-sdk/models/step';
import UpgradeYourTrip from 'app/components/book-trip/UpgradeYourTrip/Desktop';
import ConfirmBooking from 'app/components/book-trip/ConfirmBooking';
import FormErrors from 'app/components/book-trip/FormErrors';
import SecurePayment from 'app/components/book-trip/SecurePayment';
import SaveProfile from 'app/components/book-trip/SaveProfile';
import TermsAndConditions from 'app/components/book-trip/TermsAndConditions';
import PickupInstructions from 'app/components/book-trip/PickupInstructions';
import SendBookingLink from '../SendBookingLink';
import EnhancedCancellationAmenity from '../EnhancedCancellationAmenity';
import { isMobileBrowser } from 'mz-ui-kit/utils';
import CheckboxField from 'mz-ui-kit/form/CheckboxField';
import {
  CONSENT_EMAIL_FIELD_NAME,
  AGREE_WITH_TERMS_FIELD_NAME,
} from 'app/constants';
import messages from '../messages.intl';

const FormErrorsWrapper = styled('div', {
  marginTop: '20px',
});

function ConsentToContact() {
  const isTA = useSelector(behavesAsTravelAgent);
  if (isTA) return null;

  return (
    <Field
      component={CheckboxField}
      label={<FormattedMessage message={messages.MARKETING_CONSENT} />}
      name={CONSENT_EMAIL_FIELD_NAME}
    />
  );
}

function AgreeWithTerms() {
  const trip = useSelector(getBookingTrip);
  if (!trip) return null;

  const mainStep = getMainStep(trip.steps);
  const { areTermsInternal, termsOfServiceURL } = mainStep.bookingDetails;

  return (
    <Field
      component={CheckboxField}
      label={
        <TermsAndConditions
          prefixMessage={messages.AGREE_WITH_TERMS}
          areTermsInternal={areTermsInternal}
          termsOfServiceURL={termsOfServiceURL}
        />
      }
      name={AGREE_WITH_TERMS_FIELD_NAME}
    />
  );
}

function PaidBooking({ onClick, loading }) {
  const mobile = isMobileBrowser();
  return (
    <>
      <UpgradeYourTrip mobile={mobile} />
      <SecurePayment
        onClick={onClick}
        loading={loading}
        renderBeforeButton={() => (
          <div>
            <EnhancedCancellationAmenity />
            <SaveProfile />
            <PickupInstructions />
            <ConsentToContact />
            {config.SHOW_AGREE_WITH_TERMS_CHECKBOX && <AgreeWithTerms />}
            <FormErrorsWrapper>
              <FormErrors />
            </FormErrorsWrapper>
          </div>
        )}
      />
      <ConfirmBooking />
    </>
  );
}

export default function FinishBooking(props) {
  const bookByCustomer = useSelector(isBookByCustomer);
  return bookByCustomer ? (
    <SendBookingLink {...props} />
  ) : (
    <PaidBooking {...props} />
  );
}
